import styled from '@emotion/styled'

export const StyleCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 12px;
`
export const StyleCardHeader = styled.div`
  background: ${(props: any) => props.theme.colors.secondary150};
  padding: 10px 15px;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
`
export const StyleCardBody = styled.div`
  padding: 20px 15px;
`
export const StyleCardTitle = styled.h2`
  font-size: 18px;
  color: ${(props: any) => props.theme.colors.secondary};
  font-weight: 400;
`
